import { LSE } from 'src/Api';
import Chart, {
    SOLUTION_KEY,
    CHART_TITLE,
    CHART_TYPE,
    DATA_TYPE_PRICE,
    DATA_TYPE_GROWTH10K,
    DATA_TYPE_PRICEANDNAV,
    MAIN_COLOUR,
    COMPARE_COLOURS,
    INTERVALTYPE_ONEDAY,
    INTERVALTYPE_ONEMONTH,
    INTERVALTYPE_THREEMONTH,
    CURRENCY } from 'src/Components/Organisms/Chart';

export default function SharePrice({ msid, securityToken, title = 'Share price', isFund, type, exchangeCode }) {

    if (isFund) type = 'FUND';

    const intervalType = exchangeCode === LSE || isFund ? INTERVALTYPE_ONEDAY : INTERVALTYPE_ONEMONTH;
    const intervalTypes = ['1M', '3M', '1Y', '3Y', '5Y', '10Y'];

    if (exchangeCode === LSE || isFund) {
        intervalTypes.unshift('1D');
    }

    const chartSettings = {
        mainTicker: msid,
        hideMenu: true,
        legendInfoLabel: CHART_TITLE,
        charts: {
            mainChart: {
                chartType: CHART_TYPE,
                dataType: isFund ? DATA_TYPE_GROWTH10K : DATA_TYPE_PRICE
            }
        },
        mainTickerColor: MAIN_COLOUR,
        compareColors: COMPARE_COLOURS,
        intervalType: intervalType,
        intervalBreakPointMap: {
            'default': intervalTypes,
            '600': intervalTypes
        },
        height: 600,
        showCrosshairVolume: false
    };

    const chartSettingsPriceAndNav = { ...chartSettings,
        mainTicker: {
            id: msid,
            securityToken: securityToken,
            currency: CURRENCY
        },
        charts: { ...chartSettings.charts,
            mainChart: {
                ...chartSettings.charts.mainChart,
                dataType: DATA_TYPE_PRICEANDNAV
            }
        },
        intervalType: INTERVALTYPE_THREEMONTH,
        solutionKey: SOLUTION_KEY,
        useEUTimeSeriesData: true
    };

    return <>
        <div className="card z-depth-0 margin-0">
            <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm" id="newsContent">
                <h2 className="card-title" data-testid="shareUnitPriceHeader">{title}</h2>
                <Chart instrumentType={type} defaultSettings={chartSettings} priceAndNavSettings={chartSettingsPriceAndNav} />
            </div>
        </div>
    </>
}
